import {
  getPlannerGlobalNotes,
  getPlannerTodos,
} from "../services/apiPlannerTodos";
import { useMappedQuery } from "./queryUtils";

export function usePlannerTodos() {
  return useMappedQuery({
    queryKey: ["todos"],
    queryFn: getPlannerTodos,
    dataKey: "todos",
  });
}

export function usePlannerGlobalNotes() {
  return useMappedQuery({
    queryKey: ["globalNotes"],
    queryFn: getPlannerGlobalNotes,
    dataKey: "globalNotes",
  });
}
